import React from 'react';
import {
    BrowserRouter as router,
    withRouter,
    Link,
} from "react-router-dom";
import Parser from "html-react-parser";
import LanguageSwitch from '../language-switch';
import ConfigurationService from '../../services/configuration-service';

import './header-selection-style.css'
function HeaderSelection(props) {

    let handlePushFindMyDeal = () => {
        props.history.push('/find-my-deal');
    }

    const logo = require('../../elements/images/logo_positive_center.svg').default;
    let { dictionary, selectionId, currentSelectionListing, agentId, currentProjectLogo,width, pageIsLoaded = false} = props;

    const languagePrefix = ConfigurationService.getCurrentLanguagePrefix();
    let pathName = '';
    if (document.location.pathname.includes('/selection')) {
        if (agentId !== undefined && agentId !== null) pathName = `/${languagePrefix}/selection/${selectionId}/${agentId}`;
        else pathName = `/${languagePrefix}/selection/${selectionId}`
    } else {
        pathName = `/${languagePrefix}/`
    }

    if(!pageIsLoaded) return null;

    return (
        <>
            <div className={"HeaderSelection"}>
                <div className={"HeaderSelectionLogo"}>
                    <Link to={pathName}>
                        <img src={currentProjectLogo === null ? logo : currentProjectLogo} alt=""></img>
                    </Link>
                </div>
                {/* <div className={"HeaderSelectionBack"}>
                    {currentSelectionListing !== undefined && currentSelectionListing !== null ? (<Link to={pathName}>&lt; Back to list</Link>) : null}
                </div> */}

                {currentProjectLogo === null ? (
                    <div className={"HeaderSelectionPoweredBy"}>
                        <div className={"PoweredBy"} onClick={handlePushFindMyDeal}>
                            {Parser(dictionary.slogan_powered_by)}
                        </div>
                    </div>
                ) : (
                    <div className={"HeaderSelectionPresented"}>
                        {width<1000?(null):(<LanguageSwitch allowedLanguages={props.allowedLanguages} />)}
                        {/* <div className={"PoweredBy"} onClick={()=>{props.history.push('/')}}>
                            Presented by SmartLuxe
                        </div> */}
                    </div>
                )}



            </div>
            <div className={"HeaderSelectionBackMobile"}>
                {currentSelectionListing !== undefined && currentSelectionListing !== null && currentSelectionListing.length > 0 ? (<Link to={pathName}>&lt; Back to list</Link>) : null}
            </div>
        </>

    )
}

export default withRouter(HeaderSelection);